import * as React from "react";
import { useContext } from "react";
import { ContingencyPlanningType } from "../../../../ViewModel/ContingencyPlanningType";
import { EditProjectContext } from "../../../EditProjectContext";
import { updateRoutePropertyOnProject } from "./UpdateRoutePropertyOnProject";
import { isProjectReadOnly } from "../../../IsProjectReadOnly";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { DropDownList } from "../../../../../Layout/Inputs/DropDownList";
import { RouteNumberAreaInputProps } from "./RouteNumberAreaInputProps";

export function ContingencyPlanningTypeInput({
  route,
  disabled = false,
}: RouteNumberAreaInputProps) {
  const projectContextProps = useContext(EditProjectContext);
  const { project } = projectContextProps;

  const list = [
    {
      text: "None",
      value: ContingencyPlanningType.None,
    },
    {
      text: "TMS",
      value: ContingencyPlanningType.TMS,
    },
    {
      text: "CMMS",
      value: ContingencyPlanningType.CMMS,
    },
  ];

  return (
    <DropDownList
      label="Contingency Planning Type"
      list={list}
      value={route.ContingencyPlanningType}
      onChange={(value) => {
        updateRoutePropertyOnProject(
          "ContingencyPlanningType",
          value,
          route.RouteNumber || "",
          projectContextProps
        );
      }}
      disabled={isProjectReadOnly(project) || disabled}
    />
  );
}
